export interface Globals {
  clarityCode: string;
  production: boolean;
  urlFrontShopHubbix: string;
  onTrustTokenId: string;
  decouvrirUrl: string;
}

export const EMPTY_GLOBALS: Globals = {
  clarityCode: '',
  production: true,
  urlFrontShopHubbix: '',
  onTrustTokenId: '',
  decouvrirUrl: '',
};
